export const initialState = {
  capexData: null,
  errorRequestCapex: false,
  uploadedFileSuccess: false,
  errorUploadFile: false,
  errorUploadFileKey: null,
  errorDownloadFile: false,
  blobFile: null,
}

export default () => ({ ...initialState })
